import React, { useEffect, useState } from "react";
import { fetchHijriDate } from "../../services/hijriService";

const Header = ({ timingColor, textColor, currentTime, prayerData }) => {
  const [hijriDate, setHijriDate] = useState("...");

  const currentDateStr = currentTime
    ? currentTime.format("DD-MM-YYYY")
    : null;

  useEffect(() => {
    if (!currentDateStr) return;

    const getHijri = async () => {
      try {
        const lat = prayerData?.startTimes?.latitude;
        const long = prayerData?.startTimes?.longitude;
        const rawHijri = await fetchHijriDate(currentDateStr, lat, long);
        setHijriDate(rawHijri);
      } catch (e) {}
    };

    getHijri();
  }, [currentDateStr, prayerData]);

  if (!currentTime) return null;

  const gregorianDate = currentTime.format("dddd DD MMM YYYY");
  const timeString = currentTime.format("h:mm");
  const seconds = currentTime.format("ss");
  const amPm = currentTime.format("A");

  return (
    <div
      className="w-full flex flex-col sm:flex-row justify-between items-center"
      style={{
        paddingInline: "2svh",
        paddingBlock: "0.6svh",
      }}
    >
      {/* Left: Dates */}
      <div
        className="flex flex-col text-center sm:text-left"
        style={{ color: textColor }}
      >
        <div
          className="font-medium"
          style={{ fontSize: "2.2svh" }}
        >
          {gregorianDate}
        </div>

        <div
          className="font-medium"
          style={{ fontSize: "2.2svh" }}
        >
          {hijriDate}
        </div>
      </div>

      {/* Right: Time */}
      <div
        className="flex items-start font-[Digital-7]"
        style={{
          color: timingColor,
          marginTop: "0.6svh",
        }}
      >
        {/* Hour : Minute */}
        <div
          className="leading-none"
          style={{
            fontSize: "6svh",
          }}
        >
          {timeString}
        </div>

        {/* Seconds + AM/PM */}
        <div
          className="flex flex-col items-start leading-tight"
          style={{
            marginLeft: "0.8svh",
            marginTop: "0.4svh",
          }}
        >
          <div style={{ fontSize: "2svh" }}>
            {seconds}
          </div>

          <div style={{ fontSize: "1.8svh" }}>
            {amPm}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
